module.exports = __webpack_public_path__ + "img/logo-footer.91193d76.png";